export default function formatMoney(n) {
  if (n.length > 3) return n.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  else return n;
}
